import { Component, OnInit } from '@angular/core';
import { MessageBrokerService } from 'lms-api';
import { Message } from 'lms-api';

@Component({
  selector: 'app-message-display',
  templateUrl: './message-display.component.html',
  styleUrls: ['./message-display.component.scss'],
})
export class MessageDisplayComponent implements OnInit {
  public MessageQueue: Map<number, Message>;

  constructor(private messageBrokerService: MessageBrokerService) {
    this.MessageQueue = new Map<number, Message>();
    setInterval(() => { this.CleanupExpired() }, 1000);
  }

  ngOnInit() {
    this.messageBrokerService.OnNextMessage.subscribe(message => {
      let msgExists = false;
      this.MessageQueue.forEach(m => {
        msgExists = msgExists || m.Message == message.Message;
      });
      if (!msgExists) {
        this.MessageQueue.set(message.Id, message);
      }
    });
  }

  private CleanupExpired() {
    for (var key of this.MessageQueue.keys()) {
      let message = this.MessageQueue.get(key);
      if (message.Expires != null && message.Expires < new Date().getTime()) {
        this.MessageQueue.delete(key);
      }
    };
  }

  Close(messageId: number) {
    this.MessageQueue.delete(messageId);
  }

}
